import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  icon: string
  title: string
  description: string
  index: number
}

export default function ServiceCard({ icon, title, description, index }: ServiceCardProps) {
  return (
    <div 
      className={`reveal stagger-${index + 1} card-hover group p-8 border border-border hover:border-primary transition-all duration-500 bg-card`}
    >
      <div className="mb-6 w-12 h-12 flex items-center justify-center border border-border group-hover:border-primary transition-colors">
        <Icon name={icon as any} size={24} className="text-primary" />
      </div>
      <h3 className="text-2xl font-semibold tracking-tight mb-4 text-card-foreground">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {description}
      </p>
    </div>
  )
}